module.exports = __webpack_public_path__ + "img/enroll-icon-bg.4829ae16.png";